import { type FC, type PropsWithChildren, useState } from 'react';

import { DropdownHeader } from './dropdownHeader';

type Props = PropsWithChildren & {
  title: string;
  subtitle?: string;
  sectionCount: number;
  additionalHeaderElements?: JSX.Element;
};

export const PanelSectionDropdown: FC<Props> = ({
  title,
  subtitle = undefined,
  children = undefined,
  sectionCount,
  additionalHeaderElements = undefined,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(true);
  return (
    <div>
      <DropdownHeader
        additionalElements={additionalHeaderElements}
        count={sectionCount}
        isOpen={isOpen}
        subtitle={subtitle}
        title={title}
        onToggleOpen={() => {
          setIsOpen((prev) => !prev);
        }}
      />
      {isOpen && <div className="flex flex-col gap-3 p-3">{children}</div>}
    </div>
  );
};
